import qs from 'qs';

import type { IParseOptions } from 'qs';

export const parseQuery = <T extends Record<string, unknown>>(search: string, options?: IParseOptions) =>
  qs.parse(search, { ...options, ignoreQueryPrefix: true }) as unknown as T;
